import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRoot: {
    height: '100%',
  },
  lineTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
  rowName: {
    fontWeight: 500,
    fontSize: 13,
    color: theme.palette.primary.main,
  },
  rowValue: {
    fontWeight: 500,
    fontSize: 13,
    color: theme.palette.primary.main,
  },
  lineBar: {
    height: 13,
    borderRadius: 5,
  },
  barDelivered: {
    backgroundColor: theme.palette.dashboard.chart.phishing.delivered,
  },
  barViewed: { backgroundColor: theme.palette.dashboard.chart.phishing.viewed },
  barClicks: { backgroundColor: theme.palette.dashboard.chart.phishing.clicks },
  barComprised: {
    backgroundColor: theme.palette.dashboard.chart.phishing.compromised,
  },
  barCompleted: {
    backgroundColor: theme.palette.statuses.approved,
  },
}))

export default useStyles
